import React, {useEffect, useContext } from 'react'
import ScrollToTop from '../../../Shared/ScrollToTop';
import { NavLink } from 'react-router-dom';
import ServicesImg from '../../../../assets/images/weerp/web-image/business/services.png'; 
import { ProjectTypeContext } from '../../../../ContextHandle';
export default function Services({ setActivePage, sectionRefs, setDefaultWebActiveMenu }) {
  
    var projectType = useContext(ProjectTypeContext);
    const projectName = projectType.projectName;
    const panelName   = 'Business panel';
    projectType = projectType.projectType;
      /* eslint-disable */
    useEffect(() => {
        setActivePage(1011);
        document.title = 'Services | ' + projectName + ' web';
        setDefaultWebActiveMenu(2);
    }, [projectName,setActivePage,setDefaultWebActiveMenu]);
    /* eslint-enable */
    return (
        <div className='d-flex flex-column justify-content-between doc-page'>
            <ScrollToTop></ScrollToTop>
            <div className=" right-content-box-width">
                <nav  >
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href={`/${projectType}/introduction`}><i className='fa fa-home'></i></a></li>
                        <li className="breadcrumb-item" aria-current="page">{panelName}</li>
                        <li className="breadcrumb-item active" aria-current="page">Services</li>
                    </ol>
                </nav>
                <div id="activitylogs" ref={sectionRefs['8']}>
                    <h4 className=" font-weight-bold mt-5  ">Services</h4>
                    <p  >Business admin can manage multiple service  and price. And the services can be sold. </p> 
                    <div className='pt-3'>
                        <img src={ServicesImg} className="w-100 rounded" alt="Acity logs " />
                    </div> 
                </div>

                <div className="d-flex justify-content-between border-top mt-5">
                    <div className="text-start mt-4">
                        <NavLink to={`/${projectType}/business/employees`} className="text-decoration-none">
                            <a href='/' className="mb-0 text-decoration-none text-secondary">Previous <i className="bi bi-caret-left" /></a>
                            <h4 className='pagination-title'>Employees</h4>
                        </NavLink>
                    </div>
                    <div className="text-end my-2">
                        <NavLink to={`/${projectType}/business/products`} className="text-decoration-none">
                            <a href="#login" id="quickStartGuide" className="mb-0 text-decoration-none text-secondary">Next <i className="bi bi-caret-right" /></a>
                            <h4 className='pagination-title'>Products</h4>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    )
}
